function getWebPSource(src) {
  const url = new URL(src);
  return `${src}${url.search ? '&' : '?'}webp=1`;
}

export default getWebPSource;
